var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTireAtShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 66,
    rx: 2,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.93 47.695V21.57a3.266 3.266 0 00-3.266-3.265H28.336a3.265 3.265 0 00-3.266 3.265v26.125m22.86 0H25.07m22.86 0h3.265m-3.265 0h-8.164m-14.696 0h-3.265m3.265 0h8.164m6.532 0v-8.164a1.633 1.633 0 00-1.633-1.633h-3.266a1.633 1.633 0 00-1.633 1.633v8.164m6.532 0h-6.532m-1.632-22.86h1.632m-1.632 6.532h1.632m6.532-6.531h1.632m-1.632 6.531h1.632",
    stroke: "#8A8989",
    strokeWidth: 3.266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/tire-at-shop.8d87e6de.svg";
export { SvgTireAtShop as ReactComponent };